import { css } from '@emotion/css'
import { spacing, fontSize, shorthandHelper, colors, hexToRgba, accessiblyHidden } from '@offerzen/pinata-shame'

const styles = {
  menu: css({
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: spacing.default,
  }),

  accessiblyHidden: css(accessiblyHidden),

  wrapper: css({
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: hexToRgba(colors.oxfordBlue, 0.5),
    transition: 'opacity 0.2s',
  }),

  overlay: css({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    cursor: 'pointer',
  }),

  nav: css({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    marginLeft: 'auto',
    height: '100%',
    width: '75%',
    backgroundColor: colors.oxfordBlue,
    borderLeft: `1px solid ${colors.blueZodiac}`,
    overflowY: 'auto',
    transition: 'transform 0.3s',
  }),

  navItem: css({
    position: 'relative',
    borderBottom: `1px solid ${colors.blueZodiac}`,
  }),

  link: css({
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    color: hexToRgba(colors.white, 0.6),
    padding: spacing.medium,
    borderRight: '4px solid transparent',
    transition: 'color 0.2s',

    '& svg': {
      color: hexToRgba(colors.white, 0.6),
    },

    '&:hover': {
      color: colors.white,

      '& svg': {
        color: colors.white,
      },
    },

    '&:focus': {
      outline: 'none',
      color: colors.white,

      '& svg': {
        color: colors.white,
      },
    },
  }),

  buttonLink: css({
    background: 'none',
    border: 'none',
  }),

  activeSubLink: css({
    borderRight: `4px solid ${colors.cornflowerBlue}`,
    color: colors.white,
  }),

  activeLink: css({
    borderRight: `4px solid ${colors.cornflowerBlue}`,
    color: colors.white,
    backgroundColor: colors.blueZodiac,

    '& svg': {
      color: colors.white,
    },
  }),

  activeSubNav: css({
    '&::before': {
      content: '""',
      backgroundColor: colors.blueZodiac,
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },

    '& > *': {
      position: 'relative',
    },
  }),

  subNav: css({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    marginTop: -spacing.small,
    position: 'relative',
  }),

  subLink: css({
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    color: hexToRgba(colors.white, 0.6),
    padding: shorthandHelper([spacing.default, spacing.large * 2]),
    borderRight: '4px solid transparent',
    fontSize: fontSize.small,
    transition: 'color 0.2s',

    '&:hover': {
      color: colors.white,
    },

    '&:focus': {
      outline: 'none',
      color: colors.white,
    },
  }),

  icon: css({
    marginRight: spacing.default,
  }),
}

export default styles

export const wrapperTransition = status => {
  switch (status) {
    case 'entering':
      return css({
        opacity: 0,
      })

    case 'entered':
      return css({
        opacity: 1,
      })

    case 'exiting':
    case 'exited':
    default:
      return css({
        opacity: 0,
      })
  }
}

export const navTransition = status => {
  switch (status) {
    case 'entering':
      return css({
        transform: 'translateX(100%)',
      })

    case 'entered':
      return css({
        transform: 'translateX(0)',
      })

    case 'exiting':
    case 'exited':
    default:
      return css({
        transform: 'translateX(100%)',
      })
  }
}
